// src/components/ReceiptList.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "./DashboardLayout";
import "./invoice-form.css";

const API_BASE = process.env.REACT_APP_API_BASE || "https://dairy.server.statify.co.ke";

function ReceiptListContent() {
  const navigate = useNavigate();
  const [receipts, setReceipts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deletingId, setDeletingId] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadReceipts();
  }, []);

  async function loadReceipts() {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`${API_BASE}/api/receipts/`);
      if (!res.ok) {
        const txt = await res.text().catch(() => "");
        throw new Error(txt || "Failed to fetch receipts");
      }
      const list = await res.json();
      setReceipts(Array.isArray(list) ? list : []);
    } catch (err) {
      console.error("Load receipts error:", err);
      setError("Unable to load receipts. Check server.");
      setReceipts([]);
    } finally {
      setLoading(false);
    }
  }

  async function handleDelete(id) {
    if (!window.confirm("Delete this receipt? This cannot be undone.")) return;
    setDeletingId(id);
    try {
      const res = await fetch(`${API_BASE}/api/receipts/${id}/`, { method: "DELETE" });
      if (!res.ok) throw new Error("Delete failed");
      await loadReceipts();
      alert("Receipt deleted");
    } catch (err) {
      console.error(err);
      alert("Failed to delete receipt");
    } finally {
      setDeletingId(null);
    }
  }

  return (
    <div className="form-card">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h2 style={{ margin: 0 }}>Receipts</h2>
        <button className="btn btn-success" onClick={() => navigate("/receipts/new")}>
          + Create Receipt
        </button>

      </div>

      <div style={{ marginTop: 12 }}>
        {error && <div className="muted" style={{ marginBottom: 12 }}>{error}</div>}
        {loading ? (
          <div className="muted">Loading receipts…</div>
        ) : (
          <table className="compact-table" style={{ marginTop: 8 }}>
            <thead>
              <tr>
                <th>Receipt #</th>
                <th>Customer</th>
                <th>Total</th>
                <th>Txn Type</th>
                <th>Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {receipts.length === 0 && (
                <tr><td colSpan={6} style={{ padding: 12, textAlign: "center" }}>No receipts found.</td></tr>
              )}
              {receipts.map(r => (
                <tr key={r.id}>
                  <td>{r.receipt_number || `#${r.id}`}</td>
                  <td>{r.customer?.name || r.customer_name || "-"}</td>
                  <td>{Number(r.total_amount || 0).toFixed(2)}</td>
                  <td>{r.transaction_type || "-"}</td>
                  <td>{r.date ? new Date(r.date).toLocaleString() : "-"}</td>
                  <td style={{ whiteSpace: "nowrap" }}>
                    <div style={{ display: "flex", gap: "8px" }}>
                      <button
                        className="btn-ghost small-btn"
                        onClick={() => navigate(`/receipt-view/${r.id}`)}
                      >
                        View
                      </button>

                      <button
                        className="btn small-btn"
                        onClick={() => navigate(`/receipt-form/${r.id}`)}
                      >
                        Edit
                      </button>

                      <button
                        className="btn btn-danger small-btn"
                        onClick={() => handleDelete(r.id)}
                        disabled={deletingId === r.id}
                      >
                        {deletingId === r.id ? "Deleting..." : "Delete"}
                      </button>
                    </div>
                  </td>

                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default function ReceiptList(props) {
  const { noLayout } = props || {};
  const content = <ReceiptListContent {...props} />;
  if (noLayout) return content;
  return <DashboardLayout>{content}</DashboardLayout>;
}
